import { db, storage } from '../../../firebase'

const actions = {
    async fetchUser({ commit }, id) {
        try {
            const userRef = await db
                .collection('users')
                .where('slug', '==', id)
                .get()

            const userMap = userRef.docs.map(user => ({
                id: user.id,
                ...user.data()
            }))

            const user = userMap[0]

            commit('setCurrentUser', user)

            if(user === undefined) {
                return false
            } else {
                return true
            }
        } catch(error) {
            return false
        }
    },
    

    async fetchLoggedInUser({ commit }, id) {
        try {
            await db
                .collection('users')
                .doc(id)
                .onSnapshot((doc) => {
                    var data = doc.data()
                    commit('setLoggedInUser', data)
                    
                    return () => cleanUp()
                })
        } catch(error) {
            console.log(error)
        }
    },
    

    async fetchUsers({ commit }) {
        const usersRef = await db
            .collection('users')
            .where('roles', 'array-contains', 'artist')
            .get()

        const users = usersRef.docs.map(user => ({
            id: user.id,
            ...user.data()
        }))

        commit('setUsers', users)
    },

    // UPDATE PROFILE
    async updateProfile({ commit }, { params, originalCover, hasNewCover, originalAvatar, hasNewAvatar }) {
        try {
            await db
                .collection('users')
                .doc(params.id)
                .update(params.userData)

            if(hasNewCover) {
                var storageRef = storage.refFromURL(originalCover)
                await storageRef.delete()
                console.log(storageRef + ' deleted')
            }
            if(hasNewAvatar) {
                var storageRef = storage.refFromURL(originalAvatar)
                await storageRef.delete()
                console.log(storageRef + ' deleted')
            }

            return true
        } catch(err) {
            console.log(err)
        }
    },

    // UPLOAD FILE
    uploadFileToStore({ commit }, payload) {
        return new Promise((resolve, reject) => {
            var storageRef = storage.ref(payload.filePath)

            storageRef.put(payload.file)
            .then(() => {
                console.log('Uploaded ' + payload.file.name)
                storageRef.getDownloadURL()
                .then((url) => { 
                    console.log('Url of the uploaded file is ' + url)
                    resolve(url)
                })
                .catch((error) => {
                    reject(error)
                })
            })
            .catch(() => console.log('Error while uploading ' + payload.file.name))    
        })
    },

    setUserListDialog({ commit }, dialog) {
        commit('setUserListDialog', dialog)
    },

    setLastVisitedSlug({ commit }, slug) {
        commit('setLastVisitedSlug', slug)
    },

    acceptCookies({ commit }, preference) {
        commit('setCookiePreference', preference)
    },

    setPreferredLanguage({ commit }, languagePreference) {
        commit('setLanguagePreference', languagePreference)
    },

    setPreferredTheme({ commit }, theme) {
        commit('setThemePreference', theme)
    },

    setPreferredScheme({ commit }, color) {
        commit('setSchemePreference', color)
    },

    setSensitivePreference({ commit }, preference) {
        commit('setSensitivePreference', preference)
    },

    toggleTimelinePreference({ commit }, timeline) {
        commit('setTimelinePreference', timeline)
    },

    toggleOrderPreference({ commit }, order) {
        commit('setOrderPreference', order)
    },
}

export default actions